import { useMemo } from "react";
import { FormHelperText } from "@mui/material";

import Box from "../Box";
import Label from "./label";
import UploadBox from "./uploadBox";
import Helpers from "../../commons/helpers";
import useImageUploader from "./useImageUploader.hook";
import { UploadFileResponse } from "../../commons/interfaces";
import { FileAccessMode, Mode } from "../../constants/enums";

import { uploadBox } from "./styles";

interface IProps {
    mode?: Mode;
    fileId?: string;
    label: string;
    title: string;
    description: string;
    required?: boolean;
    errorMessage?: string;
    folderPath?: string;
    accessMode?: FileAccessMode;
    tooltip?: string;
    optimize?: boolean;
    onChangeImage: (res?: UploadFileResponse) => void;
}

const SingleImageUploader = ({
    mode,
    fileId,
    label,
    title,
    description,
    required,
    errorMessage,
    folderPath,
    accessMode,
    tooltip,
    optimize,
    onChangeImage,
}: IProps) => {
    const {
        error,
        uploadProgress,
        originalFileId,
        uploading,
        pausing,
        imageInputId,
        imageInputRef,
        handleRemove,
        handleTerminateUpload,
        handleContinueOrPauseUpload,
        uploadFile,
    } = useImageUploader({
        fileId,
        errorMessage,
        folderPath,
        accessMode,
        optimize,
        onChangeImage,
    });

    const errorMsg = useMemo(() => errorMessage || error, [error, errorMessage]);

    return (
        <>
            <Label label={label} required={required} tooltip={tooltip} isError={!Helpers.isNullOrEmpty(errorMsg)} />

            <Box sx={(theme) => uploadBox(theme, { isError: !Helpers.isNullOrEmpty(errorMsg) })}>
                <UploadBox
                    mode={mode}
                    title={title}
                    description={description}
                    uploadProgress={uploadProgress}
                    originalFileId={originalFileId}
                    uploading={uploading}
                    pausing={pausing}
                    imageInputId={imageInputId}
                    imageInputRef={imageInputRef}
                    handleRemove={handleRemove}
                    handleTerminateUpload={handleTerminateUpload}
                    handleContinueOrPauseUpload={handleContinueOrPauseUpload}
                    uploadFile={uploadFile}
                    optimize={optimize}
                />

                <FormHelperText color="error" sx={(theme) => ({ color: `${theme.palette.error.main} !important` })}>
                    {errorMsg}
                </FormHelperText>
            </Box>
        </>
    );
};

export default SingleImageUploader;
